import React, { useCallback, useMemo } from "react"
import { dispatchResponseEvent, SCROLL_TO_EVENT } from "queues/ResponsesEmitter"
import { errorsReported } from "toasts/AppError"
import { usePostContext } from "posts/PostContext"
import { useRefreshPostResponses } from "posts/posts.selectors"
import { InlineArticleComposer } from "./Responses"

export const InlineEditor = () => {
    const { responding } = usePostContext()

    return useMemo(() => {
        if (!responding) {
            return null
        }
        return <InlineEditorInner />
    }, [responding])
}

const InlineEditorInner = () => {
    const { post: response, responding, setResponding } = usePostContext()
    const refresh = useRefreshPostResponses()

    const handlePublish = useCallback(errorsReported(async (post) => {
        await refresh()
        setResponding(false)        
        dispatchResponseEvent(SCROLL_TO_EVENT, { postId: post._id })
    }), [refresh])

    if (!responding) {
        return null
    }

    const handleDiscard = () => {
        setResponding(false)
    }

    return (
        <InlineArticleComposer
            to={response}
            onDiscard={handleDiscard}
            onPublish={handlePublish} />
    )
}
